import React, { useEffect, useState } from "react";
import workerAPI from "../api/workerAPI";
import FaceWatcher from "./FaceWatcher";

function WorkerDashboard({ token }) {
  const [worker, setWorker] = useState(null);
  const [loading, setLoading] = useState(true);

  // Load worker info from localStorage or API
  useEffect(() => {
    const fetchWorker = async () => {
      try {
        const saved = localStorage.getItem("worker");
        let workerData = saved ? JSON.parse(saved) : null;

        // Optional: fetch latest from API
        if (workerData?._id) {
          const { data } = await workerAPI.get(`/${workerData._id}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          workerData = data;
          localStorage.setItem("worker", JSON.stringify(data));
        }

        setWorker(workerData);
      } catch (err) {
        console.error("Failed to load worker:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchWorker();
  }, [token]);

  if (loading) return <div>Loading worker data...</div>;
  if (!worker) return <div>No worker data found. Please login again.</div>;

  return (
    <div>
      <h2>Welcome, {worker.username}</h2>
      <FaceWatcher workerId={worker._id} token={token} />
      {/* Other dashboard components */}
    </div>
  );
}

export default WorkerDashboard;
